export default __webpack_public_path__ + "static/media/system_profile.1d209942.jpg";